import type { Commit } from 'vuex'

import * as API from '@/modules/matrix/api/matrixApi'
import type { MatrixClient } from '../../api/matrixClient'
import type {
  IChainDetails,
  IChainsList,
} from '@/modules/matrix/interfaces/chains.interface'

export interface ChainsState {
  chainsList: IChainsList
  chainDetails: IChainDetails
  pageIdChains: number
  activeLittleTabID: number | null
}

export function createChains(API: MatrixClient) {
return {
  namespaced: true,
  state(): ChainsState {
    return {
      chainsList: {} as IChainsList,
      chainDetails: {} as IChainDetails,
      pageIdChains: 1,
      activeLittleTabID: null,
    }
  },
  actions: {
    getChainsList({ commit, state }: { commit: Commit; state: ChainsState }) {
      return API.getListOfChains(state.pageIdChains).then((response) => {
        commit('SET_CHAINS_LIST', response.data)
      })
    },
    getChainDetail({ commit }: { commit: Commit }, id: string) {
      return API.getChainDetail(id).then((response) => {
        commit('SET_CHAIN_DETAIL', response.data)
      })
    },
  },
  mutations: {
    SET_CHAINS_LIST(state: ChainsState, chainsList: IChainsList) {
      state.chainsList = chainsList
    },
    SET_CHAIN_DETAIL(state: ChainsState, chainDetails: IChainDetails) {
      state.chainDetails = chainDetails
    },
    SET_PAGE_ID_CHAINS(state: ChainsState, pageIdChains: number) {
      state.pageIdChains = pageIdChains
    },
    SET_ACTIVE_LITTLE_TAB(state: ChainsState, id: number) {
      state.activeLittleTabID = id
    },
  },
}
}

export default createChains(API)
